import { useEffect } from "react";

import { useSignalsContextOptional } from "../contexts/SignalsContext";
import { useActiveBrokerAccount } from "./useActiveBrokerAccount";
import { useActiveBrokerCapabilities } from "./useActiveBrokerCapabilities";
import { brokerSupportsLiveBrokerAccountsApi } from "../utils/brokerLiveSync";

/**
 * Loads GET /broker/account/snapshot for the active broker when live sync is configured.
 * Skips import-only brokers (custom_csv) and brokers without supports_auto_sync.
 */
export function useLoadActiveBrokerSnapshot(options?: {
  refresh?: boolean;
  enabled?: boolean;
}): void {
  const signals = useSignalsContextOptional();
  const { activeAccountCode, activeBrokerName } = useActiveBrokerAccount();
  const { capabilities } = useActiveBrokerCapabilities(activeAccountCode, activeBrokerName);
  const enabled = options?.enabled ?? true;
  const refresh = options?.refresh ?? true;

  useEffect(() => {
    if (!enabled) return;
    const loadAccountSnapshot = signals?.loadAccountSnapshot;
    if (!loadAccountSnapshot || !activeBrokerName) return;
    if (!brokerSupportsLiveBrokerAccountsApi(capabilities)) return;
    void loadAccountSnapshot({ refresh, broker_name: activeBrokerName });
  }, [
    enabled,
    refresh,
    signals?.loadAccountSnapshot,
    activeBrokerName,
    capabilities,
  ]);
}
